/* eslint-disable */


/**
 * Create styles for `<ProfilePage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ProfilePage />` styles
 */
const profilePageStyles = ({ theme }) => ({
  fab: {
    bottom: 20,
    margin: 0,
    position: `fixed`,
    right: 20,
  },
  field: {
    marginBottom: theme.spacing(1) * 2,
  },
  fieldValue: {
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    whiteSpace: `nowrap`,
  },
  icon: {
    color: `darkgray`,
  },
  profileHeader: {
    marginBottom: theme.spacing(1) * 2,
  },
  root: {},
});

export default profilePageStyles;
